import request from "@/utils/request";
import {IUserModel} from "./types";

export const defaultUserData: IUserModel = {
  id: null,
  username: null,
  password: null,
  telephone: null,
  staffCode: null,
  name: null,
  jobPositionId: null,
  code: null,
  roleId: null,
  viewId: null,
};

export const getUsers = (params: any) =>
  request({
    url: "/users",
    method: "get",
    params,
  });

export const getUsersForAdmin = (params: any) =>
    request({
        url: "/users_admin",
        method: "get",
        params,
    });

export const changeUserAccount = (data: any) =>
    request({
        url: "/users/account",
        method: "post",
        data,
    });
export const getUsersByJobPosition = (jobPositionType: string) =>
  request({
    url: `/users/${jobPositionType}`,
    method: "get",
  });

export const getUsersByJobPositions = (params: { jobPositionTypes: string }) =>
  request({
    url: `/fixed-job-positions-users`,
    method: "GET",
    params,
  });

export const createUser = (data: IUserModel) =>
  request({
    url: "/users",
    method: "post",
    data,
  });

export const getUserInfo = () =>
  request({
    url: "/users/info",
    method: "GET",
  });

export const getUserPermissions = () =>
  request({
    url: "/permissions/role-tree",
    method: "GET",
  });

export const updateUser = (username: string, data: any) =>
  request({
    url: `/users/${username}`,
    method: "put",
    data,
  });

export const deleteUser = (id: string) =>
  request({
    url: `/users/${id}`,
    method: "delete",
  });

export const login = (data: any) =>
  request({
    url: "/users/action/login",
    method: "post",
    data,
  });

export const logout = () =>
  request({
    url: "/users/action/logout",
    method: "post",
  });

export const register = (data: any) =>
  request({
    url: "/users/register",
    method: "post",
    data,
  });

export const getProductManagerUser = () =>
  request({
    url: "/users/product-manager",
    method: "get",
  });

// /users/refresh
export const postRefresh = () =>
  request({
    url: "/users/refresh",
    method: "post"
  });

export const getUserByRole:any = (roleNames) =>
    request({
        url: "/users/all-user-by-role",
        method: "GET",
        params: {
            roleNames
        }
    });
